import { Button, Col, Form, Row, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { dayjs } from "../../../../Utilities/dayjs";
import VoucherServices from "../../../Services/VoucherServices";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { useClient } from "../../../Context/ClientContext";
import { useTheme } from "../../../Context/ThemeContext";
import { LockFilled, UnlockFilled } from "@ant-design/icons";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
const LockMonth = () => {
  const [form] = Form.useForm();
  const { currentClient, companySettings } = useClient();
  const { themeData } = useTheme();
  const [monthsList, setMonthsList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [selMonthProps, setSelMonthProps] = useState<any>();
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [selMonthLockType, setSelMonthLockType] = useState<boolean>();
  const LockVoucherMonth = () => {
    try {
      setLoading(true);
      form.validateFields().then(async (val: any) => {
        const lockMonthProps = val.lockMonth;
        setSelMonthProps(lockMonthProps);
        let SelMonthValueLockType = monthsList?.find(
          (mon: any) => mon.value === lockMonthProps
        );
        let res = await VoucherServices.postLockVoucherMonth(
          currentClient?.id!,
          lockMonthProps,
          !SelMonthValueLockType?.locked
        );
        if (res.result) {
          setSelMonthLockType(!SelMonthValueLockType?.locked);
          setLoading(false);
          setTrigger((prev: any) => !prev);
          setConfirmation(false);
        } else {
          openNotification("error", res.message);
          setLoading(false);
          setConfirmation(false);
        }
      });
    } catch (error) {
      setLoading(false);
      setConfirmation(false);
    }
  };
  const getMonthsList = async () => {
    const monthsList = await VoucherServices.getLockVoucherMonths(
      currentClient?.id!
    );
    console.log("Months List: ", monthsList?.result);

    if (monthsList !== null) {
      // let startMonth = dayjs(currentClient?.financialYearBegin);
      let currentMonth = dayjs();
      let monthsListOptions: any = [];
      for (
        let startMonth = dayjs(currentClient?.financialYearBegin);
        startMonth.isBefore(currentMonth);
        startMonth = startMonth.add(1, "month") // Reassign `startMonth`
      ) {
        monthsListOptions.push({
          key: dayjs(startMonth).format("DD-MM-YYYY"),
          value: dayjs(startMonth).toISOString(),
          label: (
            <Row>
              <Col span={16} style={{ textAlign: "left" }}>
                {startMonth.format("MMM")}-{startMonth.year()}
              </Col>
              {monthsList?.result?.find(
                (mon: any) =>
                  dayjs(mon.lockedMonth).toISOString() ===
                  dayjs(startMonth).toISOString()
              )?.isLocked ? (
                <Col
                  span={8}
                  style={{
                    color: "red",
                    textAlign: "right",
                    paddingRight: "5px",
                  }}
                >
                  <LockFilled style={{ color: "#F2003C" }} />
                </Col>
              ) : (
                <Col
                  span={8}
                  style={{
                    color: "green",
                    textAlign: "right",
                    paddingRight: "5px",
                  }}
                >
                  <UnlockFilled style={{ color: `${themeData?.themeColor}` }} />
                </Col>
              )}
            </Row>
          ),
          title: "",
          locked:
            monthsList?.result?.find(
              (mon: any) =>
                dayjs(mon.lockedMonth).toISOString() ===
                dayjs(startMonth).toISOString()
            )?.isLocked ?? false,
        });
      }
      setMonthsList(monthsListOptions);
    }
  };

  useEffect(() => {
    getMonthsList();
    if (selMonthProps) {
      form.setFieldValue("lockMonth", selMonthProps);
    }
  }, [currentClient?.id, trigger]);

  return (
    <Row>
      <Col span={24}>
        <Row>
          <Col>
            <Form form={form} onFinish={() => setConfirmation(true)}>
              <Form.Item name="lockMonth" label="Select month to lock" required>
                <Select
                  placeholder="Place select a month to lock/unlock"
                  style={{ width: "300px" }}
                  options={monthsList}
                  onChange={(val: string) => {
                    let SelMonthValueLockType = monthsList?.find(
                      (mon: any) => mon.value === val
                    );
                    setSelMonthLockType(SelMonthValueLockType.locked);
                  }}
                ></Select>
              </Form.Item>
              <Form.Item>
                <Button loading={loading} type="primary" htmlType="submit">
                  {selMonthLockType ? "Unlock month" : "Lock month"}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Col>
      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            LockVoucherMonth();
          }}
          text={
            selMonthLockType
              ? "Are you sure you want to unlock the selected month? This action will allow modifications to vouchers in this month."
              : "Are you sure you want to lock the selected month? This action will prevent any modifications to vouchers in this month."
          }
        />
      )}
    </Row>
  );
};

export default LockMonth;
